import { SET_CE_REPORTING_FILTER } from "../../Actions/ActionConstants";

const CEReportingFilterReducer = (state = null, action) => {
    if (action.type === SET_CE_REPORTING_FILTER) {
        return action.data;
    } else {
        return state;
    }
};
export default CEReportingFilterReducer
